import React from 'react';
import { useDropzone } from 'react-dropzone';
import type { DragAndDropProps } from '@components/atoms/drag-and-drop/types';
import type { FileWithPreview } from '@models/types';
import cn from 'classnames';

import { DragAndDropWrapper } from './styles';

export const DragAndDrop: React.FC<DragAndDropProps> = ({
    onChange,
    children,
    isMultiple = false,
    accept = {
        'image/jpeg': [],
        'image/png': [],
        'image/*': [],
    },
    className,
}) => {
    const { getRootProps, getInputProps } = useDropzone({
        accept,
        onDrop: (acceptedFiles) => {
            const files = acceptedFiles.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                }),
            );

            onChange(files as unknown as FileWithPreview[]);
        },
    });

    return (
        <DragAndDropWrapper {...getRootProps()} className={cn('drag-and-drop', className)}>
            <input {...getInputProps()} multiple={isMultiple} />
            {children}
        </DragAndDropWrapper>
    );
};
